export default __webpack_public_path__ + "static/clutch-3bb8456d4a5cdbd12d8f58c3b541b881.svg";